<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-success btn-block">
        <li class="fa fa-recycle"></li> ENVIAR RESET DE GPS
    </button>
</template>
<script>
    import {Comandos} from '../../class';
    import {Bus} from '../../class/bus';
    export default {
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async reset () {
                await Comandos.resetGps(this.id_rastreador);
                Bus.$emit('comandos');
            }
        }
    }
</script>
